import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';
import { ROUTES } from '../../config/routes';
import type { PermissionKey } from '../../config/permissions';

interface AuthGuardProps {
  children:    React.ReactNode;
  permission?: PermissionKey;
}

export const AuthGuard: React.FC<AuthGuardProps> = ({ children, permission }) => {
  const { user, can, initialized } = useAuthStore();
  const location = useLocation();

  if (!initialized) {
    return <div className="min-h-dvh navy-bg grid place-items-center"><div className="w-10 h-10 rounded-full border-2 border-gold-500/20 border-t-gold-300 animate-spin" /></div>;
  }

  if (!user) {
    return <Navigate to={ROUTES.login} state={{ from: location }} replace />;
  }

  if (permission && !can(permission)) {
    return <Navigate to={ROUTES.unauthorized} replace />;
  }

  return <>{children}</>;
};
